namespace GeniuzPOS.Inventory {
    export class IcStockAdjustInDtColumns {
        static columnsKey = 'Inventory.IcStockAdjustInDt';
    }
}
